import { render, staticRenderFns } from "./ModalAddCompany.vue?vue&type=template&id=059222ba&scoped=true"
import script from "./ModalAddCompany.vue?vue&type=script&lang=js"
export * from "./ModalAddCompany.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCompany.vue?vue&type=style&index=0&id=059222ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059222ba",
  null
  
)

export default component.exports